// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__lK5cv","header":"PatientBlock_header__1ansN","label":"PatientBlock_label__pEJTW","option":"PatientBlock_option__2ZKRU"};